 export const skillsData = [
    'HTML',
    'CSS',
    'Figma',
    'Javascript',
    'CSS',
    'React',
    'Bootstrap',
    'Firebase',
    'Python',
    'Typescript',
    'PostgreSQL',
    'MySQL',
    'Flutter',
    'Dart',
    'Java',
    'Git',
]
